import {
    Box,
    Button
} from "@mui/material";
import {
    KeyboardArrowLeft,
    KeyboardArrowRight
} from "@mui/icons-material";
import React, {
    useMemo
} from "react";

import { ResponsiveToolTip } from "./ResponsiveToolTip";
import { VIEW_MODE } from "./IssueDashboardTable";

type WeekNavigatorProps = {
    viewMode: VIEW_MODE;
    navigateToPrev: () => void;
    navigateToNext: () => void;
    disablePrevButton: boolean;
    disableNextButton: boolean;
};

export const CalendarNavigator = (props: WeekNavigatorProps) => {
    const { viewMode, navigateToNext, navigateToPrev, disablePrevButton, disableNextButton } = props;
    const unit = useMemo(() => {
        switch (viewMode) {
            case VIEW_MODE.WEEKLY:
                return "Week";
            case VIEW_MODE.DAILY:
                return "Day";
            default:
                return "Week";
        }
    }, [viewMode]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <ResponsiveToolTip title={disablePrevButton ? "Earliest possible date reached" : ""}>
                <span>
                    <Button
                        onClick={() => navigateToPrev()}
                        disabled={disablePrevButton}
                        sx={{
                            minWidth: 0,
                            color: theme => theme.palette.text.primary,
                            whiteSpace: "nowrap"
                        }}
                        startIcon={<KeyboardArrowLeft />}
                    >
                        Prev {unit}
                    </Button>
                </span>
            </ResponsiveToolTip>
            <ResponsiveToolTip title={disableNextButton ? "Latest possible date reached" : ""}>
                <span>
                    <Button
                        onClick={() => navigateToNext()}
                        disabled={disableNextButton}
                        sx={{
                            minWidth: 0,
                            color: theme => theme.palette.text.primary,
                            whiteSpace: "nowrap"
                        }}
                        endIcon={<KeyboardArrowRight fontSize="large" />}
                    >
                        Next {unit}
                    </Button>
                </span>
            </ResponsiveToolTip>
        </Box>
    );
};